import { useAnimByChangeProp } from '@patrianna/shared-hooks'
import cx from 'classnames'
import { useEffect, useState } from 'react'
import type { ReactNode } from 'react'

import { useAppSelector } from 'src/store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'

import classes from './styles.module.scss'

type Props = {
  children: ReactNode
  className?: string
  disabledAtTime?: number
}

export default function AnimateWhenCurrencyChange(props: Props) {
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const [disabled, setDisabled] = useState(!!props.disabledAtTime)

  const { animClassName } = useAnimByChangeProp({
    duration: 700,
    animateClassName: classes.animate,
    listenProp: activeCurrency,
    mountWithoutAnimation: true,
  })

  useEffect(() => {
    if (props.disabledAtTime) {
      const timeout = setTimeout(() => {
        setDisabled(false)
      }, props.disabledAtTime)

      return () => clearTimeout(timeout)
    }

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className={cx(!disabled && animClassName, props.className)}>{props.children}</div>
}
